import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { get } from 'lodash';
import { validateReduxForm } from 'common/form';
import { validations } from '@unite-us/app-components';
import {
  DateField,
} from '@unite-us/ui';
import today from 'common/utils/today';
import { Spinner } from 'common/spinners';
import moment from 'moment';
import FormFooter from 'common/form/FormButtons/components/FormFooter';
import { fetchServiceCase, updateServiceCase } from 'actions/Case/Contact/Group';

export class ServiceCaseProgramExitForm extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onSubmit(values) {
    const { groupId, serviceCase, contactId } = this.props;

    return this.props.updateServiceCase(groupId, contactId, serviceCase.id, {
      closed_date: values.closed_date,
    }).then(() => {
      this.props.fetchServiceCase(groupId, contactId, serviceCase.id);
      this.onClose();
    });
  }

  onClose() {
    this.props.closeModal();
  }

  render() {
    const {
      registerField, fields, handleSubmit, submitting, serviceCase,
    } = this.props;
    const minDate = moment.unix(get(serviceCase, 'opened_date') - 1).format('MM/DD/YYYY');

    if (submitting) {
      return <Spinner text="Updating Closed Date..." />;
    }

    return (
      <form className="service-case-program-exit-form" onSubmit={handleSubmit(this.onSubmit)}>
        <DateField
          className="service-case-program-exit-form__date-field"
          id="service-case-program-exit-input__closed_date"
          ref={registerField}
          field={fields.closed_date}
          inline={false}
          label="Closed Date"
          validations={validations.isRequired}
          maxDate={today()}
          minDate={minDate}
          style={{ container: { minHeight: '250px' } }}
          required
        />
        <FormFooter
          onSubmitLabel="Save"
          handleSubmit={() => {
            handleSubmit(this.onSubmit)();
          }}
          submitDisabled={submitting}
          onCancel={this.onClose}
        />
      </form>
    );
  }
}

ServiceCaseProgramExitForm.propTypes = {
  serviceCase: PropTypes.object.isRequired,
  contactId: PropTypes.string.isRequired,
  registerField: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  fetchServiceCase: PropTypes.func.isRequired,
  updateServiceCase: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    initialValues: {
      closed_date: get(ownProps, 'serviceCase.closed_date'),
    },
  };
}

const fields = [
  'closed_date',
];

export default validateReduxForm(
  {
    form: 'editServiceCaseClosedDate',
    fields,
  },
  mapStateToProps,
  {
    fetchServiceCase,
    updateServiceCase,
  },
)(ServiceCaseProgramExitForm);
